import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSignUpStore = defineStore('signUp', () => {
  // State
  const status = ref('idle')
  const signUpData = ref({})
  const fc = ref(null)
  const initialRegistrationData = () => ({
    account: null,
    currency: null,
    site: null,
    strategy: null,
    uid: null,
    uidSite: null,
    agentId: null,
  })
  const registrationData = ref(initialRegistrationData())
  const error = ref(null)

  // Getters
  const getStatus = computed(() => status.value)
  const getSignUpData = computed(() => signUpData.value)
  const getFc = computed(() => fc.value)
  const getRegistrationData = computed(() => registrationData.value)
  const getError = computed(() => error.value)

  const loading = computed(() => status.value === 'authentication')
  const isAuthenticated = computed(() => status.value === 'authenticated')

  // Actions
  function setStatus(data) {
    status.value = data
  }

  function setSignUpData(data) {
    signUpData.value = data
  }

  function setFc(data) {
    fc.value = data
  }

  function setRegistrationData(data) {
    registrationData.value = data
  }

  function setError(data) {
    error.value = data
  }

  function resetRegistrationData() {
    registrationData.value = initialRegistrationData()
  }

  function resetState() {
    status.value = 'idle'
    signUpData.value = {}
    resetRegistrationData()
    error.value = null
  }

  return {
    // State
    status,
    signUpData,
    fc,
    registrationData,
    error,

    // Getters
    getStatus,
    getSignUpData,
    getFc,
    getRegistrationData,
    getError,
    loading,
    isAuthenticated,

    // Actions
    setStatus,
    setSignUpData,
    setFc,
    setRegistrationData,
    setError,
    resetState,
    resetRegistrationData,
  }
})
